import { render } from "./BillingDashboard.vue?vue&type=template&id=bfa9f660&scoped=true"
import script from "./BillingDashboard.vue?vue&type=script&lang=js"
export * from "./BillingDashboard.vue?vue&type=script&lang=js"

import "./BillingDashboard.vue?vue&type=style&index=0&id=bfa9f660&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfa9f660"]])

export default __exports__